






















import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import AcademicYear from './AcademicYear.vue';

@Component({
    computed: {
        ...mapState(['activeStudy']),
        ...mapGetters(['excurStudy'])
    },
    components: {
        AcademicYear
    }
})
export default class AcademicYears extends Vue {
}
